// extracted by mini-css-extract-plugin
module.exports = {"article":"review_article__cQqwr","heading":"review_heading__gZ5Y9","attributes":"review_attributes__gOBa5"};